import * as tslib_1 from "tslib";
import { Value, Attr, Record, Text } from '@swim/recon';
var UiEnvelope = (function () {
    function UiEnvelope() {
    }
    Object.defineProperty(UiEnvelope.prototype, "tag", {
        get: function () {
            return this.constructor.tag;
        },
        enumerable: true,
        configurable: true
    });
    UiEnvelope.prototype.toRecon = function () {
        return this.toValue().toRecon();
    };
    Object.defineProperty(UiEnvelope, "tag", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    UiEnvelope.fromValue = function (value) {
        switch (value.tag) {
            case 'append': return UiAppendEnvelope.fromValue(value);
            case 'prepend': return UiPrependEnvelope.fromValue(value);
            case 'insert': return UiInsertEnvelope.fromValue(value);
            case 'remove': return UiRemoveEnvelope.fromValue(value);
            case 'state': return UiStateEnvelope.fromValue(value);
            case 'model': return UiModelEnvelope.fromValue(value);
            default: return undefined;
        }
    };
    UiEnvelope.parseRecon = function (input) {
        return UiEnvelope.fromValue(Value.parseRecon(input));
    };
    return UiEnvelope;
}());
export { UiEnvelope };
var UiTreeEnvelope = (function (_super) {
    tslib_1.__extends(UiTreeEnvelope, _super);
    function UiTreeEnvelope(parent, child, target, body) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._child = child;
        _this._target = target;
        _this._body = body;
        return _this;
    }
    UiTreeEnvelope.prototype.parent = function (parent) {
        if (parent === undefined) {
            return this._parent;
        }
        else {
            return this.copy(parent, this._child, this._target, this._body);
        }
    };
    UiTreeEnvelope.prototype.child = function (child) {
        if (child === undefined) {
            return this._child;
        }
        else {
            return this.copy(this._parent, child, this._target, this._body);
        }
    };
    UiTreeEnvelope.prototype.target = function (target) {
        if (target === undefined) {
            return this._target;
        }
        else {
            return this.copy(this._parent, this._child, target, this._body);
        }
    };
    UiTreeEnvelope.prototype.body = function (body) {
        if (body === undefined) {
            return this._body;
        }
        else {
            body = Value.fromAny(body);
            return this.copy(this._parent, this._child, this._target, body);
        }
    };
    UiTreeEnvelope.prototype.toValue = function () {
        var header = Record.empty(this._target ? 3 : 2)
            .slot('parent', this._parent)
            .slot('child', this._child);
        if (this._target) {
            header.slot('target', this._target);
        }
        return Attr.of(this.tag, header).concat(this._body);
    };
    UiTreeEnvelope.fromValue = function (value, E) {
        var parent;
        var child;
        var target = '';
        var header = value.header(E.tag);
        header.forEach(function (item, index) {
            if (item.key instanceof Text) {
                var key = item.key.value;
                if (key === 'parent') {
                    parent = item.toValue().stringValue(parent);
                }
                else if (key === 'child') {
                    child = item.toValue().stringValue(child);
                }
                else if (key === 'target') {
                    target = item.toValue().stringValue(target);
                }
            }
            else if (item instanceof Value) {
                if (index === 0) {
                    parent = item.stringValue(parent);
                }
                else if (index === 1) {
                    child = item.stringValue(child);
                }
                else if (index === 2) {
                    target = item.stringValue(target);
                }
            }
        }, this);
        if (parent !== undefined && child !== undefined) {
            var body = value.body();
            return new E(parent, child, target, body);
        }
        return undefined;
    };
    return UiTreeEnvelope;
}(UiEnvelope));
export { UiTreeEnvelope };
var UiViewEnvelope = (function (_super) {
    tslib_1.__extends(UiViewEnvelope, _super);
    function UiViewEnvelope(child, body) {
        var _this = _super.call(this) || this;
        _this._child = child;
        _this._body = body;
        return _this;
    }
    UiViewEnvelope.prototype.parent = function (parent) {
        if (parent === undefined) {
            return '';
        }
        else {
            return this;
        }
    };
    UiViewEnvelope.prototype.child = function (child) {
        if (child === undefined) {
            return this._child;
        }
        else {
            return this.copy(child, this._body);
        }
    };
    UiViewEnvelope.prototype.target = function (target) {
        if (target === undefined) {
            return '';
        }
        else {
            return this;
        }
    };
    UiViewEnvelope.prototype.body = function (body) {
        if (body === undefined) {
            return this._body;
        }
        else {
            body = Value.fromAny(body);
            return this.copy(this._child, body);
        }
    };
    UiViewEnvelope.prototype.toValue = function () {
        var header = Record.empty(1)
            .slot('child', this._child);
        return Attr.of(this.tag, header).concat(this._body);
    };
    UiViewEnvelope.fromValue = function (value, E) {
        var child;
        var header = value.header(E.tag);
        header.forEach(function (item, index) {
            if (item.key instanceof Text) {
                var key = item.key.value;
                if (key === 'child') {
                    child = item.toValue().stringValue(child);
                }
            }
            else if (item instanceof Value) {
                if (index === 0) {
                    child = item.stringValue(child);
                }
            }
        }, this);
        if (child !== undefined) {
            var body = value.body();
            return new E(child, body);
        }
        return undefined;
    };
    return UiViewEnvelope;
}(UiEnvelope));
export { UiViewEnvelope };
var UiAppendEnvelope = (function (_super) {
    tslib_1.__extends(UiAppendEnvelope, _super);
    function UiAppendEnvelope(parent, child, target, body) {
        return _super.call(this, parent, child, target, body) || this;
    }
    UiAppendEnvelope.prototype.copy = function (parent, child, target, body) {
        return new UiAppendEnvelope(parent, child, target, body);
    };
    UiAppendEnvelope.fromValue = function (value) {
        return UiTreeEnvelope.fromValue(value, UiAppendEnvelope);
    };
    Object.defineProperty(UiAppendEnvelope, "tag", {
        get: function () {
            return 'append';
        },
        enumerable: true,
        configurable: true
    });
    UiAppendEnvelope.of = function (parent, child, target, body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new UiAppendEnvelope(parent, child, target, body);
    };
    return UiAppendEnvelope;
}(UiTreeEnvelope));
export { UiAppendEnvelope };
var UiPrependEnvelope = (function (_super) {
    tslib_1.__extends(UiPrependEnvelope, _super);
    function UiPrependEnvelope(parent, child, target, body) {
        return _super.call(this, parent, child, target, body) || this;
    }
    UiPrependEnvelope.prototype.copy = function (parent, child, target, body) {
        return new UiPrependEnvelope(parent, child, target, body);
    };
    UiPrependEnvelope.fromValue = function (value) {
        return UiTreeEnvelope.fromValue(value, UiPrependEnvelope);
    };
    Object.defineProperty(UiPrependEnvelope, "tag", {
        get: function () {
            return 'prepend';
        },
        enumerable: true,
        configurable: true
    });
    UiPrependEnvelope.of = function (parent, child, target, body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new UiPrependEnvelope(parent, child, target, body);
    };
    return UiPrependEnvelope;
}(UiTreeEnvelope));
export { UiPrependEnvelope };
var UiInsertEnvelope = (function (_super) {
    tslib_1.__extends(UiInsertEnvelope, _super);
    function UiInsertEnvelope(parent, child, target, body) {
        return _super.call(this, parent, child, target, body) || this;
    }
    UiInsertEnvelope.prototype.copy = function (parent, child, target, body) {
        return new UiInsertEnvelope(parent, child, target, body);
    };
    UiInsertEnvelope.fromValue = function (value) {
        return UiTreeEnvelope.fromValue(value, UiInsertEnvelope);
    };
    Object.defineProperty(UiInsertEnvelope, "tag", {
        get: function () {
            return 'insert';
        },
        enumerable: true,
        configurable: true
    });
    UiInsertEnvelope.of = function (parent, child, target, body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new UiInsertEnvelope(parent, child, target, body);
    };
    return UiInsertEnvelope;
}(UiTreeEnvelope));
export { UiInsertEnvelope };
var UiRemoveEnvelope = (function (_super) {
    tslib_1.__extends(UiRemoveEnvelope, _super);
    function UiRemoveEnvelope(parent, child, target, body) {
        if (body === void 0) { body = Value.Absent; }
        return _super.call(this, parent, child, target, body) || this;
    }
    UiRemoveEnvelope.prototype.copy = function (parent, child, target, body) {
        return new UiRemoveEnvelope(parent, child, target, body);
    };
    UiRemoveEnvelope.fromValue = function (value) {
        return UiTreeEnvelope.fromValue(value, UiRemoveEnvelope);
    };
    Object.defineProperty(UiRemoveEnvelope, "tag", {
        get: function () {
            return 'remove';
        },
        enumerable: true,
        configurable: true
    });
    UiRemoveEnvelope.of = function (parent, child, target, body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new UiRemoveEnvelope(parent, child, target, body);
    };
    return UiRemoveEnvelope;
}(UiTreeEnvelope));
export { UiRemoveEnvelope };
var UiStateEnvelope = (function (_super) {
    tslib_1.__extends(UiStateEnvelope, _super);
    function UiStateEnvelope(child, body) {
        return _super.call(this, child, body) || this;
    }
    UiStateEnvelope.prototype.copy = function (child, body) {
        return new UiStateEnvelope(child, body);
    };
    UiStateEnvelope.fromValue = function (value) {
        return UiViewEnvelope.fromValue(value, UiStateEnvelope);
    };
    Object.defineProperty(UiStateEnvelope, "tag", {
        get: function () {
            return 'state';
        },
        enumerable: true,
        configurable: true
    });
    UiStateEnvelope.of = function (child, body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new UiStateEnvelope(child, body);
    };
    return UiStateEnvelope;
}(UiViewEnvelope));
export { UiStateEnvelope };
var UiModelEnvelope = (function (_super) {
    tslib_1.__extends(UiModelEnvelope, _super);
    function UiModelEnvelope(child, body) {
        return _super.call(this, child, body) || this;
    }
    UiModelEnvelope.prototype.copy = function (child, body) {
        return new UiModelEnvelope(child, body);
    };
    UiModelEnvelope.fromValue = function (value) {
        return UiViewEnvelope.fromValue(value, UiModelEnvelope);
    };
    Object.defineProperty(UiModelEnvelope, "tag", {
        get: function () {
            return 'model';
        },
        enumerable: true,
        configurable: true
    });
    UiModelEnvelope.of = function (child, body) {
        if (body === void 0) { body = Value.Absent; }
        body = Value.fromAny(body);
        return new UiModelEnvelope(child, body);
    };
    return UiModelEnvelope;
}(UiViewEnvelope));
export { UiModelEnvelope };
//# sourceMappingURL=data:application/json;base64,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